import { CognitoUserPool } from "amazon-cognito-identity-js";

console.log(process.env)

export default new CognitoUserPool({
    UserPoolId: process.env.REACT_APP_COGNITO_POOL_ID,
    ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID
})